var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column",staticStyle:{"height":"100vh"}},[_c('custom-header'),_c('div',{staticClass:"layout-wrapper flex"},[_c('custom-sidebar'),_c('div',{staticClass:"layout-content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }